import {Injectable} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {EventDetailSetting} from '../../models/event-detail-setting';

@Injectable()
export class CreateEventFormValidator {

  constructor(private fb: FormBuilder) {}

  createForm(model: EventDetailSetting, rooms) {
    const form = this.fb.group({
      'summary': [model.summary, Validators.compose([Validators.required, Validators.maxLength(255)])],
      'email': [model.email],
      'group_id': [model.group_id],
      'room_id': [model.room_id],
      'start': [''],
      'end': [''],
      'start_date': [''],
      'end_date': [''],
      'repeat_parent_id': model.repeat_parent_id
    });

    model.room_id ? form.controls['room_id'].setValue(model.room_id, {onlySelf: true}) :
      form.controls['room_id'].setValue(rooms[0] ? rooms[0].id : null, {onlySelf: true});
    model.group_id ? form.controls['group_id'].setValue(model.group_id, {onlySelf: true}) :
      form.controls['group_id'].setValue(null, {onlySelf: true});

    return form;
  }

  getValidationMessages() {
    return {
      'summary': {
        'required': 'Summary is required.',
        'maxlength': 'Summary may not be greater than 255 characters.'
      },
      'email': {
        'pattern': 'Email is invalid.'
      },
      'startTime': {
        'required': 'Start is required.'
      },
      'endTime': {
        'required': 'End is required.',
        'invalid': 'End time should be greater than start time.'
      }
    };
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/modal-event/create-event-form.validator.ts